import { Text, Thumbnail } from '@wix/design-system';
import clsx from 'clsx';
import React, { FC } from 'react';
import styles from './ProductThumbnail.scss';

interface ProductThumbnailProps {
  imageUrl: string;
  name: string;
  selected?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
  showLabel?: boolean;
  onClick?: () => void;
}

export const ProductThumbnail: FC<ProductThumbnailProps> = ({
  imageUrl,
  name,
  selected,
  disabled,
  isLoading,
  showLabel = true,
  onClick,
}) => (
  <div className={styles.productThumbnail}>
    <Thumbnail selected={selected} disabled={disabled} onClick={onClick}>
      <img
        src={imageUrl}
        alt={name}
        className={clsx(styles.productThumbnailImage, isLoading && styles.loading)}
      />
    </Thumbnail>
    {showLabel && (
      <div className={styles.productThumbnailLabel}>
        <Text ellipsis size="small" weight="normal" maxLines={3}>
          {name}
        </Text>
      </div>
    )}
  </div>
);
